<template>
    <div class="checker-radio">
        <label for="usedDxComponents">{{ label }}</label>
        <div class="checker-radio__inputsWrapper">
            <label 
                v-for="(option, i) in options" 
                :key="i"
                :class="[{ error: inputState == 'error' }, 'checker-radio__input']"
            >
                <input type="radio" name="usedDxComponents" :value="option.value" v-model="radioValue" @change="onChange">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="option.value == radioValue" v-bind:class="'checker-radio__icon--checked'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="12" cy="12" r="9.25" stroke="currentColor" stroke-width="1.5"/><circle cx="12" cy="12" r="6" fill="currentColor"/></svg>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:class="'checker-radio__icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="12" cy="12" r="9.25" stroke="currentColor" stroke-width="1.5"/></svg>
                <span>{{ option.label }}</span>
            </label>
        </div>
        <div v-if="inputState == 'error'" class="errorMessage">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm1-14a1 1 0 10-2 0 1 1 0 002 0zm-1 9a1 1 0 001-1v-5a1 1 0 10-2 0v5a1 1 0 001 1z" fill="currentColor"/></svg>
            <span>{{ errMessage }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "CheckerRadio",
    data() {
        return {
            radioValue: null
        }
    },
    props: {
        options: {
            type: Array,
            required: true,
        },
        label: {
            type: String
        },
        inputState: {
            type: String,
        },
        errMessage: {
            type: String,
        }
    },
    methods: {
        onChange() {
            this.$emit('input', this.radioValue);
        }
    }
}
</script>

<style lang="scss" scoped>
.checker-radio {
    display: flex;
    flex-direction: column;
    gap: rem(16);
}

.checker-radio__inputsWrapper {
    display: flex;
    gap: rem(50);
}

.checker-radio__input {
    display: flex;
    gap: rem(10);

    input {
        display: none;
    }
}

.checker-radio__icon {
    color: $color-cool-grey-50;

    &--checked {
        color: $color-blue-40;
    }

    &:hover {
        color: $color-blue-40;
    }
}

.error svg {
	color: $color-red-80;
}

.errorMessage {
	display: flex;
	color: $color-red-80;
	gap: rem(5);
	
	span {
		color: $color-red-80;
	}
}
</style>